import { Component, input } from '@angular/core';
import { ToggleHeightDirective } from '../../../shared/directives/toggle-height.directive';
import { IconPlusMinusToggleComponent } from '../../../shared/components/icon-plus-minus-toggle/icon-plus-minus-toggle.component';

@Component({
  selector: 'app-faq-accordion-item',
  standalone: true,
  imports: [ToggleHeightDirective, IconPlusMinusToggleComponent],
  templateUrl: './faq-accordion-item.component.html',
  styleUrl: './faq-accordion-item.component.scss',
})
export class FaqAccordionItemComponent {
  id = input.required<string>();
  title = input.required<string>();
}
